export default __webpack_public_path__ + "static/media/nextBtn.98f78a91.png";